
import { httpAxios } from "../utils/httpAxios";


export const getAllApplicationsService = async()=>{
    const result= await httpAxios.get('/admin/get/app/records').then((res)=>{
        return res.data
        }).catch((err)=>{
            return err.response.data;
        });  
        return result;
};
export const addApplicationsService = async(data)=>{
    const result= await httpAxios.post('/admin/add/app/record',data).then((res)=>{
        return res.data
        }).catch((err)=>{
            return err.response.data;
        });  
        return result;
};


export const updateApplicationsService = async(data)=>{
    const result= await httpAxios.post('/admin/update/app/record',data).then((res)=>{
        return res.data
        }).catch((err)=>{
            return err.response.data;
        });  
        return result;
};
export const deleteApplicationService = async(id)=>{
    const result= await httpAxios.get(`/admin/del/app/record/${id}`).then((res)=>{
        return res.data
        }).catch((err)=>{
            return err.response.data;
        });  
        return result;
};

export const getAllFilterService = async()=>{
    const result= await httpAxios.get('/user/get/app/records').then((res)=>{
        return res?.data
        }).catch((err)=>{
            return err?.response?.data;
        });  
        return result;
};

export const getAllFilterEmployee = async(data)=>{
    console.log(data,'service')

    const formData = new FormData();
    formData.append('emp',data || '')
    const result= await httpAxios.post('/user/get/employers',formData).then((res)=>{
        return res?.data
        }).catch((err)=>{
            return err?.response?.data;
        });  
        return result;
};

export const applyAllFilterService = async(data,page,sorting=[],perPage)=>{
    const formData = new FormData();

for (const key in data) {
    if(data[key].length>0){
    if(key !=="search_field"){
       
        if(key !=="statuses"){
            for(var i=0; i<data[key].length; i++){
                formData.append(`${key}[${i}]`, data[key][i])
            }
        }
        else{
            formData.append(`${key}[]`, data[key]);
        }
       
        // data[key].map((e,index)=> formData.append(`${key}[${index}]`, e))
       
    }else{

        formData.append(key, data[key]);
    }
}
}
if(sorting.length > 0){
    formData.append('sort_by',sorting[0].id);
    formData.append('sort_order',sorting[0].desc ? "asc" : "desc");
}
    formData.append('page',page);
    formData.append('per_page',perPage);
    // formData.append('search_field','all');

    const result= await httpAxios.post('/user/apply/filter',formData).then((res)=>{
        return res.data
        }).catch((err)=>{
            return err?.response?.data;
        });  
        return result;
};
// export const addUserService= async(data)=>{
//     const result= await axiosInstance.post('/admin/add/user',data).then((res)=>{
//         return res.data
//         }).catch((err)=>{
//             return err.response.data;
//         });  
//         return result;
// }